import { FilterScope } from '@mairistem/finances-utils';
import { ListeContainer, useListe } from '@mairistem/liste';
import React from 'react';
import ProjetListe from '@/src/components/ProjetListe/ProjetListe';

const ProjetListeContainer = () => {
	const defaultFilters = {
		status: FilterScope.filterIn([0, 1, 2, 3]),
	};

	const [projetService] = useListe(
		'/api/finances/subventionsPercues/projets',
		defaultFilters,
	);
	return (
		<ListeContainer
			type="projets"
			contains="liste"
			service={projetService}
			perPage={15}
		>
			{/* @ts-expect-error */}
			<ProjetListe />
		</ListeContainer>
	);
};

export default ProjetListeContainer;
